module.exports = __webpack_public_path__ + "static/media/case-details-es.09bc3d61.png";